export enum Role {
    NONE = "ROLE_NONE",
    USER = "ROLE_USER",
    ADMIN = "ROLE_ADMIN",
}


export const displayRole = (role: Role): string => {
    switch (role) {
        case Role.NONE:
            return "Basic";
        case Role.USER:
            return "User";
        case Role.ADMIN:
            return "Admin";
        default:
            return "";
    }
}